import "./five.css";

import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';

const EmailCube = () => {
  const [flipped, setFlipped] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleClick = () => {
    navigator.clipboard.writeText("contact@bichitras.com");
    setFlipped(true);
    if (timeoutId) clearTimeout(timeoutId);
    const id = setTimeout(() => setFlipped(false), 1200);
    setTimeoutId(id);
  };

  return (
    <div
      className="email-cube-container custom-underline"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      title="Click to copy email"
    >
      <div className={`email-cube ${flipped ? 'flipped' : ''}`}>
        <div className="email-face front">contact@bichitras.com</div>
        <div className="email-face back">COPIED !!</div>
      </div>
    </div>
  );
};

const InstagramCube = () => {
  const [flipped, setFlipped] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleClick = () => {
    setFlipped(true);
    if (timeoutId) clearTimeout(timeoutId);
    
    // Open the link after user can appreciate the animation
    setTimeout(() => {
      window.open("https://www.instagram.com/bichitrasgroup/", "_blank", "noopener,noreferrer");
    }, 800);
    
    // Flip back to original text
    const id = setTimeout(() => setFlipped(false), 1200);
    setTimeoutId(id);
  };

  return (
    <div
      className="link-cube-container custom-underline"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      title="Follow us on Instagram"
    >
      <div className={`link-cube ${flipped ? 'flipped' : ''}`}>
        <div className="link-face front">Instagram</div>
        <div className="link-face back">OPENING !!</div>
      </div>
    </div>
  );
};

const LinkedInCube = () => {
  const [flipped, setFlipped] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleClick = () => {
    setFlipped(true);
    if (timeoutId) clearTimeout(timeoutId);
    
    // Open the link after user can appreciate the animation
    setTimeout(() => {
      window.open("https://www.linkedin.com/company/bichitras/", "_blank", "noopener,noreferrer");
    }, 800);
    
    // Flip back to original text
    const id = setTimeout(() => setFlipped(false), 1200);
    setTimeoutId(id);
  };

  return (
    <div
      className="link-cube-container custom-underline"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      title="Connect with us on LinkedIn"
    >
      <div className={`link-cube ${flipped ? 'flipped' : ''}`}>
        <div className="link-face front">LinkedIn</div>
        <div className="link-face back">OPENING !!</div>
      </div>
    </div>
  );
};

const Five = () => {
  return <section className="fi">
      <Helmet>
        <title>Bichitras Engineering Studio | Get in Touch</title>
        <meta name="description" content="Read our engineering blog and get in touch with Bichitras. Contact us at contact@bichitras.com for outsourcing projects and collaborations." />
        <meta name="keywords" content="engineering blog, contact bichitras, software development contact, outsourcing contact, Nepal software company contact" />
      </Helmet>
      <section className="blog-back" id="blog">
          <h2 className="blog-head">Blog</h2>
          <p className="blog-about">
          Many voices, one blog. A first impression of how we tick. Also: <br />
          Developments, trends and opinions that move us in engineering, but also <br />
          beyond. And of course a look behind the scenes - about the development of our projects and <br />
          work come from.
          </p>
          <article className="cards">
              <h3 className="card-head">How we built our first live-stream MVP?</h3>
          </article>
          <article className="cards-2">
              <h3 className="card-head-2">Why a hospital needed engineers, not designers?</h3>
          </article>
          <article className="cards-3">
          <h3 className="card-head-3">Lessons from visualizing a real-world shopping mall</h3>
          </article>
          <div className="cards-4"></div>
          <div className="cards-5"></div>
          <div className="cards-6"></div>
      </section>
      <footer className="footer" id="contact">
          <p className="digi">Let's get physical or keep it digital</p>
          <h2 className="get-in">Get in touch</h2>
      </footer>
      <div className="credit">
        <EmailCube />
        <InstagramCube />
        <LinkedInCube />
      </div>
  </section>;
};

export default Five;
